import React from 'react';
import { FolderInput, Sparkles, Eye, FolderTree } from 'lucide-react';

const STEPS = [
  {
    icon: FolderInput,
    title: 'Point at your mess',
    body:
      'Pick a folder. Your Downloads, Desktop, Pictures, an external drive, or a synced iCloud Photos folder. Sortio works with whatever you already have, no import or migration.',
  },
  {
    icon: Sparkles,
    title: 'Tell it what you want',
    body:
      'In plain English: "organize photos by year and month based on date taken" or "file tax documents by year, separate family member documents, group house build paperwork."',
  },
  {
    icon: Eye,
    title: 'Preview every move',
    body:
      'Sortio shows you exactly where each file will go before anything moves. You can adjust folder names, skip files, or rerun with a different prompt. Undo is one click.',
  },
  {
    icon: FolderTree,
    title: 'Apply and breathe',
    body:
      "Approve the plan and Sortio files everything on your Mac. Your photos are sorted by year. Your tax docs are by year and type. Your house build paperwork is grouped by project. It's done.",
  },
];

const Workflow = () => {
  return (
    <section id="workflow" className="my-20">
      <div className="text-center mb-14">
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          How it works
        </h2>
        <p className="text-apple-300 text-lg font-light max-w-2xl mx-auto">
          Four steps from a chaotic Downloads folder to a sorted family archive you can actually
          find things in.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {STEPS.map((step, i) => {
          const Icon = step.icon;
          return (
            <div
              key={i}
              className="relative bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-6 flex flex-col"
            >
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 rounded-full bg-sortio-primary/15 border border-sortio-primary/30 flex items-center justify-center mr-3">
                  <Icon className="text-sortio-primary" size={18} />
                </div>
                <span className="text-xs font-medium uppercase tracking-wider text-apple-400">
                  Step {i + 1}
                </span>
              </div>
              <h3 className="text-lg font-medium text-apple-50 mb-2">{step.title}</h3>
              <p className="text-sm text-apple-200 leading-relaxed">{step.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Workflow;
